import { models } from 'cesg-shared';
import { appHttpService } from '../standard/http-service';

class AtaChangelogsService {
  async getAllFromId(id: string) {
    const timestampSafeAtaChangelogs = await appHttpService.request
      .url(`/changelogs/atas/${id}`)
      .get()
      .json<models.GetAtaChangelogsResponse>();

    const ataChangelogs = timestampSafeAtaChangelogs.map((changelog) => ({
      ...changelog,
      timestamp: new Date(changelog.timestamp),
    }));

    return ataChangelogs;
  }
}

export const ataChangelogsService = new AtaChangelogsService();
